module.exports = __webpack_public_path__ + "img/sound_active.2e15deb6.png";